import { PaginatorLaboratoryDynamicDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-dynamic-datasource'
import GrossingSampleService from '@/modules/grossingModule/services/grossingSampleService'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

export class GrossingSampleDatasource<T> extends PaginatorLaboratoryDynamicDatasource<T> {
    private readonly _viewAllEnabled: boolean

    constructor(laboratoryId: number, url: string, viewAllEnabled: boolean) {
        super(GrossingSampleService, laboratoryId, url)
        this._viewAllEnabled = viewAllEnabled
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        return this.service.paginator(filterModel, params, this.laboratoryId, this._url, this._viewAllEnabled)
    }
}
